import React from 'react';
import { Gift, User } from 'lucide-react';

const Header = ({ user, telegramUser }) => {
  if (!user) return null;

  // Получаем данные пользователя Telegram
  const avatarUrl = telegramUser?.photo_url;
  const username = telegramUser?.username || user.username;
  const firstName = telegramUser?.first_name;
  const lastName = telegramUser?.last_name;
  
  const displayName = username || `${firstName || ''} ${lastName || ''}`.trim() || 'User';

  return (
    <div className="bg-blue-800/50 backdrop-blur-sm p-4 flex justify-between items-center sticky top-0 z-40">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-xl overflow-hidden">
          {avatarUrl ? (
            <img 
              src={avatarUrl} 
              alt="Avatar" 
              className="w-full h-full object-cover"
            />
          ) : (
            <User className="w-6 h-6" />
          )}
        </div>
        <span className="font-medium">@{displayName}</span>
      </div>
      <div className="flex items-center gap-2 bg-blue-700/50 px-4 py-2 rounded-full">
        <Gift className="w-5 h-5 text-yellow-400" />
        <span className="font-bold">{user.balance?.toFixed(2) || '0.00'}</span>
      </div>
    </div>
  );
};

export default Header;